module.exports = __webpack_public_path__ + "img/ib.e9ea6451.jpg";